import { useState, useEffect } from "react";
import { supabase } from "../supabase";

const LOGO_B64 = "data:image/jpeg;base64,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";


const styles = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Montserrat:wght@300;400;500;600&family=Libre+Baskerville:ital@1&display=swap');

  * { box-sizing: border-box; margin: 0; padding: 0; }

  body {
    background: #F8F5F2;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
  }

  .portal-root {
    padding-top: env(safe-area-inset-top);
    padding-bottom: env(safe-area-inset-bottom);
    min-height: 100vh;
    background: #F8F5F2;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
  }

  /* TOP NAV */
  .nav {
    min-height: 58px;
    display: flex;
    align-items: center;
    padding: calc(env(safe-area-inset-top) + 10px) 28px 10px;
    border-bottom: 1px solid #DDD9D4;
    position: sticky;
    top: 0;
    background: #F8F5F2;
    z-index: 100;
    gap: 16px;
  }

  .nav-logo {
    display: flex;
    align-items: center;
    gap: 14px;
  }

  .logo-mark {
    width: 38px;
    height: 38px;
    background: #FFFFFF;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #D4D1CE;
    position: relative;
    overflow: hidden;
  }

  .logo-s {
    font-family: 'Cormorant Garamond', serif;
    font-size: 22px;
    font-weight: 300;
    color: #111111;
    line-height: 1;
  }

  .logo-slash {
    position: absolute;
    width: 2px;
    height: 14px;
    background: #E50000;
    border-radius: 1px;
  }

  .logo-slash-1 { transform: rotate(-45deg) translate(4px, -3px); }
  .logo-slash-2 { transform: rotate(-45deg) translate(-4px, 3px); }

  .nav-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 18px;
    font-weight: 300;
    letter-spacing: 0.05em;
    color: #111111;
  }

  .nav-title span {
    color: #E50000;
  }

  .nav-client {
    text-align: right;
  }

  .nav-client-name {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #111111;
  }

  .nav-client-label {
    font-size: 10px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #777770;
    margin-top: 2px;
  }

  /* HERO SECTION */
  .hero {
    padding: 60px 40px 40px;
    border-bottom: 1px solid #DDD9D4;
    position: relative;
    overflow: hidden;
  }

  .hero::before {
    content: '';
    position: absolute;
    top: 0; right: 0;
    width: 400px; height: 400px;
    background: radial-gradient(circle, rgba(229,0,0,0.04) 0%, transparent 70%);
    pointer-events: none;
  }

  .hero-eyebrow {
    font-size: 10px;
    font-weight: 500;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 16px;
  }

  .hero-heading {
    font-family: 'Cormorant Garamond', serif;
    font-size: 48px;
    font-weight: 300;
    line-height: 1.1;
    color: #111111;
    margin-bottom: 12px;
  }

  .hero-heading em {
    font-style: italic;
    color: #555550;
  }

  .hero-sub {
    font-size: 12px;
    letter-spacing: 0.06em;
    color: #777770;
    margin-top: 8px;
  }

  /* MAIN LAYOUT */
  .main {
    display: grid;
    grid-template-columns: 260px 1fr;
    min-height: calc(100vh - 140px);
  }

  /* SIDEBAR */
  .sidebar {
    border-right: 1px solid #1a1a1a;
    padding: 32px 0;
  }

  .sidebar-section {
    margin-bottom: 8px;
  }

  .sidebar-label {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #777770;
    padding: 0 28px;
    margin-bottom: 6px;
  }

  .sidebar-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 11px 28px;
    cursor: pointer;
    transition: all 0.15s ease;
    border-left: 2px solid transparent;
    position: relative;
  }

  .sidebar-item:hover {
    background: #FFFFFF;
    color: #111111;
  }

  .sidebar-item.active {
    border-left-color: #E50000;
    background: #FFFFFF;
    color: #111111;
  }

  .sidebar-item.active .sidebar-icon {
    color: #E50000;
  }

  .sidebar-icon {
    width: 16px;
    height: 16px;
    color: #777770;
    flex-shrink: 0;
  }

  .sidebar-text {
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: inherit;
  }

  .sidebar-badge {
    margin-left: auto;
    background: #E50000;
    color: #111111;
    font-size: 9px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 10px;
    letter-spacing: 0.05em;
  }

  .sidebar-divider {
    height: 1px;
    background: #EEEBE7;
    margin: 20px 28px;
  }

  /* CONTENT */
  .content {
    padding: 40px 48px;
    overflow-y: auto;
  }

  .content-header {
    margin-bottom: 36px;
  }

  .content-eyebrow {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 8px;
  }

  .content-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 32px;
    font-weight: 300;
    color: #111111;
  }

  .content-desc {
    font-size: 12px;
    color: #777770;
    margin-top: 8px;
    line-height: 1.7;
    letter-spacing: 0.03em;
  }

  /* CARDS */
  .card-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 16px;
    margin-bottom: 32px;
  }

  .card {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 28px;
    transition: border-color 0.2s ease;
    position: relative;
    overflow: hidden;
  }

  .card::before {
    content: '';
    position: absolute;
    top: 0; left: 0; right: 0;
    height: 1px;
    background: linear-gradient(90deg, transparent, rgba(229,0,0,0.3), transparent);
    opacity: 0;
    transition: opacity 0.2s ease;
  }

  .card:hover {
    border-color: #2a2a2a;
  }

  .card:hover::before {
    opacity: 1;
  }

  .card-icon-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .card-icon {
    width: 36px;
    height: 36px;
    background: #EEEBE7;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #E50000;
  }

  .card-status {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    padding: 4px 10px;
    border-radius: 1px;
  }

  .status-complete { background: rgba(229,0,0,0.1); color: #E50000; }
  .status-pending { background: rgba(176,172,168,0.1); color: #555550; }
  .status-action { background: rgba(229,0,0,0.15); color: #E50000; border: 1px solid rgba(229,0,0,0.3); }

  .card-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    font-weight: 400;
    color: #111111;
    margin-bottom: 6px;
  }

  .card-desc {
    font-size: 11px;
    color: #777770;
    line-height: 1.6;
    letter-spacing: 0.02em;
  }

  .card-action {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #E50000;
    cursor: pointer;
    transition: gap 0.2s ease;
  }

  .card-action:hover { gap: 12px; }

  /* ACCOUNT SETUP LIST */
  .setup-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }

  .setup-item {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 20px 24px;
    display: flex;
    align-items: center;
    gap: 20px;
    transition: border-color 0.2s;
  }

  .setup-item:hover { border-color: #2a2a2a; }

  .setup-item-check {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    border: 1.5px solid #2a2a2a;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: all 0.2s;
  }

  .setup-item-check.done {
    background: #E50000;
    border-color: #E50000;
  }

  .setup-item-info { flex: 1; }

  .setup-item-name {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: #111111;
    margin-bottom: 3px;
  }

  .setup-item-desc {
    font-size: 11px;
    color: #777770;
    letter-spacing: 0.02em;
  }

  .setup-item-btn {
    background: transparent;
    border: 1px solid #D4D1CE;
    color: #555550;
    font-family: 'Montserrat', sans-serif;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    padding: 8px 16px;
    cursor: pointer;
    transition: all 0.2s;
    border-radius: 1px;
  }

  .setup-item-btn:hover {
    border-color: #E50000;
    color: #E50000;
  }

  .setup-item-btn.submitted {
    border-color: #E50000;
    color: #E50000;
    background: rgba(229,0,0,0.05);
  }

  /* CREDENTIAL MODAL */
  .modal-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0,0,0,0.85);
    backdrop-filter: blur(8px);
    z-index: 200;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
  }

  .modal {
    background: #FFFFFF;
    border: 1px solid #D4D1CE;
    border-radius: 2px;
    width: 100%;
    max-width: 480px;
    padding: 40px;
    position: relative;
  }

  .modal-close {
    position: absolute;
    top: 20px; right: 20px;
    background: none;
    border: none;
    color: #777770;
    cursor: pointer;
    font-size: 20px;
    line-height: 1;
    transition: color 0.2s;
  }

  .modal-close:hover { color: #111111; }

  .modal-eyebrow {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 8px;
  }

  .modal-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 28px;
    font-weight: 300;
    color: #111111;
    margin-bottom: 6px;
  }

  .modal-desc {
    font-size: 11px;
    color: #777770;
    line-height: 1.7;
    margin-bottom: 28px;
    letter-spacing: 0.02em;
  }

  .form-group {
    margin-bottom: 18px;
  }

  .form-label {
    display: block;
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #555550;
    margin-bottom: 8px;
  }

  .form-input {
    width: 100%;
    background: #F8F5F2;
    border: 1px solid #D4D1CE;
    border-radius: 1px;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    padding: 12px 14px;
    outline: none;
    transition: border-color 0.2s;
    letter-spacing: 0.02em;
  }

  .form-input:focus { border-color: #E50000; }
  .form-input::placeholder { color: #999990; }

  .form-note {
    font-size: 10px;
    color: #777770;
    margin-top: 6px;
    letter-spacing: 0.02em;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .btn-primary {
    width: 100%;
    background: #E50000;
    border: none;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.15em;
    text-transform: uppercase;
    padding: 14px;
    cursor: pointer;
    transition: background 0.2s;
    border-radius: 1px;
    margin-top: 8px;
  }

  .btn-primary:hover { background: #cc0000; }

  /* SERVICE REQUEST */
  .service-form {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 32px;
    max-width: 600px;
  }

  .form-textarea {
    width: 100%;
    background: #F8F5F2;
    border: 1px solid #D4D1CE;
    border-radius: 1px;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    padding: 12px 14px;
    outline: none;
    transition: border-color 0.2s;
    resize: vertical;
    min-height: 120px;
    letter-spacing: 0.02em;
    line-height: 1.6;
  }

  .form-textarea:focus { border-color: #E50000; }
  .form-textarea::placeholder { color: #999990; }

  .form-select {
    width: 100%;
    background: #F8F5F2;
    border: 1px solid #D4D1CE;
    border-radius: 1px;
    color: #111111;
    font-family: 'Montserrat', sans-serif;
    font-size: 12px;
    padding: 12px 14px;
    outline: none;
    transition: border-color 0.2s;
    appearance: none;
    cursor: pointer;
  }

  .form-select:focus { border-color: #E50000; }
  .form-select option { background: #FFFFFF; }

  /* DOCUMENTS */
  .doc-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }

  .doc-item {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 18px 24px;
    display: flex;
    align-items: center;
    gap: 16px;
    transition: border-color 0.2s;
    cursor: pointer;
  }

  .doc-item:hover { border-color: #2a2a2a; }

  .doc-icon {
    width: 32px;
    height: 32px;
    background: #EEEBE7;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #E50000;
    flex-shrink: 0;
    font-size: 12px;
    font-weight: 700;
    font-family: 'Montserrat', sans-serif;
    letter-spacing: 0;
  }

  .doc-info { flex: 1; }

  .doc-name {
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 0.05em;
    color: #111111;
    margin-bottom: 3px;
  }

  .doc-meta {
    font-size: 10px;
    color: #777770;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .doc-arrow {
    color: #777770;
    transition: color 0.2s, transform 0.2s;
  }

  .doc-item:hover .doc-arrow {
    color: #E50000;
    transform: translateX(4px);
  }

  /* SYSTEM DEVICES */
  .device-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
    gap: 12px;
  }

  .device-card {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 22px;
    transition: border-color 0.2s;
  }

  .device-card:hover { border-color: #2a2a2a; }

  .device-room {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.18em;
    text-transform: uppercase;
    color: #E50000;
    margin-bottom: 10px;
  }

  .device-brand {
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    font-weight: 400;
    color: #111111;
    margin-bottom: 2px;
  }

  .device-model {
    font-size: 11px;
    color: #777770;
    letter-spacing: 0.03em;
    margin-bottom: 14px;
  }

  .device-manual {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: #555550;
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    transition: color 0.2s;
    background: none;
    border: none;
    padding: 0;
    font-family: 'Montserrat', sans-serif;
  }

  .device-manual:hover { color: #E50000; }

  /* UPGRADE */
  .upgrade-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
    gap: 14px;
  }

  .upgrade-card {
    background: #FFFFFF;
    border: 1px solid #1e1e1e;
    border-radius: 2px;
    padding: 26px;
    transition: all 0.2s;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .upgrade-card:hover {
    border-color: #E50000;
  }

  .upgrade-card::after {
    content: '';
    position: absolute;
    bottom: 0; left: 0; right: 0;
    height: 2px;
    background: #E50000;
    transform: scaleX(0);
    transition: transform 0.2s;
  }

  .upgrade-card:hover::after { transform: scaleX(1); }

  .upgrade-icon {
    font-size: 28px;
    margin-bottom: 14px;
  }

  .upgrade-title {
    font-family: 'Cormorant Garamond', serif;
    font-size: 20px;
    font-weight: 400;
    color: #111111;
    margin-bottom: 6px;
  }

  .upgrade-desc {
    font-size: 11px;
    color: #777770;
    line-height: 1.6;
    letter-spacing: 0.02em;
  }

  .upgrade-cta {
    margin-top: 16px;
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: #E50000;
  }

  /* SUCCESS STATE */
  .success-banner {
    background: rgba(229,0,0,0.08);
    border: 1px solid rgba(229,0,0,0.2);
    border-radius: 2px;
    padding: 16px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 24px;
  }

  .success-dot {
    width: 8px; height: 8px;
    background: #E50000;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .success-text {
    font-size: 11px;
    color: #555550;
    letter-spacing: 0.04em;
  }

  /* RESPONSIVE */
  @media (max-width: 768px) {
  @media (max-width: 768px) {
    * { max-width: 100%; }
    .portal-root { overflow-x: hidden; width: 100vw; }
    .main { grid-template-columns: 1fr; }
    .sidebar { display: none; }
    .hero { padding: 40px 20px 28px; }
    .hero-heading { font-size: 28px; }
    .hero-eyebrow { font-size: 9px; }
    .content { padding: 24px 16px; }
    .nav {
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      padding: calc(env(safe-area-inset-top) + 10px) 12px 10px;
      gap: 6px;
    }
    .nav-logo { gap: 8px; flex-shrink: 0; }
    .nav-logo img { height: 30px !important; max-width: 160px !important; width: auto !important; }
    .nav-logo span { font-size: 11px !important; }
    .nav-logo .designs-text { font-size: 7px !important; }
    .nav-client { text-align: right; flex-shrink: 0; }
    .nav-client-name { font-size: 10px; }
    .nav-client-label { font-size: 8px; }
    .nav-signout { display: none; }
    .cards-grid { grid-template-columns: 1fr; gap: 12px; }
    .card { padding: 20px; }
    .card-title { font-size: 18px; }
    .content-title { font-size: 28px; }
    .welcome-name { font-size: 32px; }
    .hero-sub { font-size: 11px; }
  }
`;
// --- DATA ---
const CLIENT = {
  name: "",
  address: "",
};

const ACCOUNTS = [
  {
    id: "sonos", name: "Sonos", desc: "Whole-home audio system",
    instructions: "Download the Sonos app (black icon) from the App Store or Google Play, tap 'Create Account', and sign up with your email. Once your account is created, submit your login below — Smart Tech will handle all device setup and configuration.",
    ios: "https://apps.apple.com/us/app/sonos/id1488977981",
    android: "https://play.google.com/store/apps/details?id=com.sonos.acr2&hl=en_US",
  },
  {
    id: "lutron", name: "Lutron App", desc: "Lighting & shade control",
    instructions: "Download the Lutron app and create an account using your email address. Submit your login below once done — Smart Tech will handle all device and scene programming.",
    ios: "https://apps.apple.com/us/app/lutron-app/id886753021",
    android: "https://play.google.com/store/apps/details?id=com.lutron.mmw",
  },
  {
    id: "joshai", name: "Josh AI", desc: "Voice home automation",
    installerCreates: true,
    instructions: "Your Smart Tech installer will create your Josh AI account and send you an email invite. You do not need to create an account yourself. Submit the email address you'd like associated with your system below — we'll take care of the rest including all device setup.",
    ios: "https://apps.apple.com/us/app/josh-home-intelligence/id1024805681",
    android: "https://play.google.com/store/apps/details?id=com.jstarllc.josh",
  },
  {
    id: "icpro", name: "ICView+ — ICRealtime", desc: "Surveillance & cameras",
    instructions: "Download the ICView+ app by ICRealtime. Tap 'Register' to create a new account, then submit your credentials below. Smart Tech will handle all camera setup and configuration.",
    ios: "https://apps.apple.com/us/app/icview/id1640612893",
    android: "https://play.google.com/store/apps/details?id=com.mm.android.ICView2",
  },
  {
    id: "alarm", name: "Alarm.com", desc: "Security & access control",
    installerCreates: true,
    instructions: "Your Alarm.com account will be created by Smart Tech Utah — you'll receive a welcome email once it's ready. You do not need to create an account yourself. Submit the email address you'd like used for your account below. Smart Tech will handle all device and sensor setup.",
    ios: "https://apps.apple.com/us/app/alarm-com/id315010649",
    android: "https://play.google.com/store/apps/details?id=com.alarm.alarmmobile.android",
  },
  {
    id: "unifi", name: "UniFi Access", desc: "Door & access control",
    instructions: "Download the UniFi Access app. Your account will be set up by Smart Tech Utah — you'll receive an invite email. Submit your Ubiquiti account email and password below. Smart Tech will handle all door and access device programming.",
    ios: "https://apps.apple.com/us/app/unifi-access/id1578429007",
    android: "https://play.google.com/store/apps/details?id=com.ui.access.app",
  },
  {
    id: "samsung", name: "Samsung Account", desc: "Samsung TV setup",
    instructions: "A Samsung account is required to set up your TV. Visit account.samsung.com to create one — it only takes a few minutes. Once done, submit your login below so Smart Tech can complete your TV setup and configuration.",
    ios: null,
    android: null,
    web: "https://account.samsung.com",
    webLabel: "Create Samsung Account",
  },
  {
    id: "denon", name: "Denon HEOS", desc: "Multi-room audio streaming",
    instructions: "Download the HEOS app from the App Store or Google Play and create a free HEOS account. Once your account is created, submit your login below — Smart Tech will handle all speaker setup and grouping.",
    ios: "https://apps.apple.com/us/app/heos/id843129434",
    android: "https://play.google.com/store/apps/details?id=com.dnm.heos.phone",
  },
  {
    id: "doorbird", name: "DoorBird", desc: "Video doorbell & entry",
    instructions: "Download the DoorBird app from the App Store or Google Play and create an account. Once your account is created, submit your login below — Smart Tech will handle all doorbell setup, configuration, and integration.",
    ios: "https://apps.apple.com/us/app/doorbird/id898756315",
    android: "https://play.google.com/store/apps/details?id=com.doorbird.doorbird",
  },
];

const DEVICES = [
  { room: "Living Room", brand: "Sonance", model: "VP65R In-Ceiling Speakers" },
  { room: "Living Room", brand: "Marantz", model: "SR6015 AV Receiver" },
  { room: "Master Bedroom", brand: "Lutron", model: "Caseta Pro Smart Bridge" },
  { room: "Home Theater", brand: "Kaleidescape", model: "Strato C Player" },
  { room: "Whole Home", brand: "Josh AI", model: "Josh Micro — 4 units" },
  { room: "Exterior", brand: "Luma", model: "4K PoE Dome Camera × 6" },
];

const DOCUMENTS = [
  { name: "System Overview & Network Map", type: "PDF", date: "Mar 2026" },
  { name: "Wi-Fi Network Credentials", type: "SEC", date: "Mar 2026" },
  { name: "Lutron HomeWorks — Owner's Manual", type: "PDF", date: "Lutron" },
  { name: "Kaleidescape Strato — Setup Guide", type: "PDF", date: "Kaleidescape" },
  { name: "Warranty Registration — All Systems", type: "PDF", date: "Mar 2026" },
];

const UPGRADES = [
  { icon: "🎬", title: "Outdoor Entertainment", desc: "Add weatherproof displays and Sonance landscape audio to your patio or pool deck." },
  { icon: "🔆", title: "Lutron Ketra Lighting", desc: "Upgrade to tunable lighting that adjusts color temperature throughout the day." },
  { icon: "🪟", title: "Motorized Shading", desc: "Automated roller or honeycomb shades in any room, integrated with your Lutron system." },
  { icon: "🎙️", title: "Expand Josh AI", desc: "Add Josh Micro units to additional rooms for whole-home voice coverage." },
  { icon: "📹", title: "Additional Cameras", desc: "Expand your ICRealtime surveillance to cover additional zones or interior areas." },
  { icon: "🎵", title: "More Audio Zones", desc: "Extend distributed audio to bedrooms, bathrooms, or outdoor spaces." },
];

// --- SVG ICONS ---
const IconHome = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <path d="M3 9.5L12 3l9 6.5V20a1 1 0 01-1 1H4a1 1 0 01-1-1V9.5z"/>
    <path d="M9 21V12h6v9"/>
  </svg>
);

const IconSetup = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <circle cx="12" cy="12" r="3"/>
    <path d="M19.07 4.93l-1.41 1.41M4.93 4.93l1.41 1.41M12 2v2M12 20v2M2 12h2M20 12h2M19.07 19.07l-1.41-1.41M4.93 19.07l1.41-1.41"/>
  </svg>
);

const IconDevices = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <rect x="2" y="3" width="20" height="14" rx="2"/>
    <path d="M8 21h8M12 17v4"/>
  </svg>
);

const IconDocs = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
    <path d="M14 2v6h6M16 13H8M16 17H8M10 9H8"/>
  </svg>
);

const IconSupport = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z"/>
  </svg>
);

const IconUpgrade = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" className="sidebar-icon">
    <path d="M12 2l3 7h7l-5.5 4 2 7L12 16l-6.5 4 2-7L2 9h7z"/>
  </svg>
);

const IconCheck = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" width="12" height="12">
    <path d="M20 6L9 17l-5-5"/>
  </svg>
);

const IconArrow = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="16" height="16" className="doc-arrow">
    <path d="M5 12h14M12 5l7 7-7 7"/>
  </svg>
);

const IconLock = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="11" height="11">
    <rect x="3" y="11" width="18" height="11" rx="2"/>
    <path d="M7 11V7a5 5 0 0110 0v4"/>
  </svg>
);

// --- VIEWS ---

function OverviewView({ setView, clientData }) {
  const [unreadCount, setUnreadCount] = useState(0);
  useEffect(() => {
    if (!clientData?.id) return;
    supabase.from("service_requests").select("thread, last_read_client, resolved").eq("client_id", clientData.id).eq("resolved", false)
      .then(({ data }) => {
        if (!data) return;
        const count = data.filter(r => (r.thread || []).some(m => m.from === "installer") && !r.last_read_client).length;
        setUnreadCount(count);
      });
  }, [clientData]);
  const assignedSystems = (clientData && clientData.systems && clientData.systems.length > 0)
    ? clientData.systems : ACCOUNTS.map(a => a.id);
  const existingCreds = (clientData && clientData.credentials) ? clientData.credentials : [];
  const submittedIds = existingCreds.map(c => c.system);
  const submitted = assignedSystems.filter(id => submittedIds.includes(id)).length;
  const total = assignedSystems.length;
  const clientName = clientData?.name || '';
  const clientAddress = clientData?.address || CLIENT.address;
  const firstName = clientName.split(' ')[0] || '';
  return (
    <div>
      <div className="content-header">
        <div className="content-eyebrow">{firstName ? `Welcome Back, ${firstName}` : 'Welcome Back'}</div>
        <div className="content-title">Your Smart Home Portal</div>
        <div className="content-desc">{clientAddress}</div>
      </div>

      {submitted < total && (
        <div className="success-banner" style={{background:'rgba(229,0,0,0.06)', borderColor:'rgba(229,0,0,0.2)', marginBottom:28}}>
          <div className="success-dot" style={{background:'#E50000', animation:'pulse 2s infinite'}}/>
          <div className="success-text">
            Action needed — {total - submitted} account{total - submitted > 1 ? 's' : ''} still require your credentials before your install can be completed.
          </div>
        </div>
      )}

      <div className="card-grid">
        <div className="card" onClick={() => setView('setup')} style={{cursor:'pointer'}}>
          <div className="card-icon-row">
            <div className="card-icon"><IconSetup/></div>
            <div className={`card-status ${submitted === total ? 'status-complete' : 'status-action'}`}>
              {submitted}/{total} Done
            </div>
          </div>
          <div className="card-title">Account Setup</div>
          <div className="card-desc">Submit credentials for your smart home systems so our team can configure everything before arrival.</div>
          <div className="card-action" onClick={() => setView('setup')}>
            {submitted < total ? 'Complete Setup' : 'View Accounts'} <span>→</span>
          </div>
        </div>

        <div className="card" onClick={() => setView('devices')} style={{cursor:'pointer'}}>
          <div className="card-icon-row">
            <div className="card-icon"><IconDevices/></div>
            <div className="card-status status-complete">{DEVICES.length} Devices</div>
          </div>
          <div className="card-title">Your System</div>
          <div className="card-desc">View every device installed in your home, with quick access to manuals and product documentation.</div>
          <div className="card-action" onClick={() => setView('devices')}>View System <span>→</span></div>
        </div>

        <div className="card" onClick={() => setView('docs')} style={{cursor:'pointer'}}>
          <div className="card-icon-row">
            <div className="card-icon"><IconDocs/></div>
            <div className="card-status status-complete">{DOCUMENTS.length} Files</div>
          </div>
          <div className="card-title">Network / WiFi</div>
          <div className="card-desc">Access your system overview, warranties, network credentials, and all installation documentation.</div>
          <div className="card-action" onClick={() => setView('docs')}>Open Vault <span>→</span></div>
        </div>

        <div className="card" onClick={() => setView('support')} style={{cursor:'pointer'}}>
          <div className="card-icon-row">
            <div className="card-icon"><IconSupport/></div>
            <div className="card-status status-pending">Support</div>
            {unreadCount > 0 && <div style={{background:"#E50000", color:"#fff", borderRadius:"50%", width:18, height:18, fontSize:10, fontWeight:700, display:"flex", alignItems:"center", justifyContent:"center"}}>{unreadCount}</div>}
          </div>
          <div className="card-title">Service Request</div>
          <div className="card-desc">Something not working right? Submit a request directly to the Smart Tech team — we'll get back to you fast.</div>
          <div className="card-action" onClick={() => setView('support')}>Request Service <span>→</span></div>
        </div>
      </div>
    </div>
  );
}

function SetupView({ setView, clientData, setClientData }) {
  const assignedSystems = (clientData && clientData.systems) ? clientData.systems : [];
  const existingCreds = (clientData && clientData.credentials) ? clientData.credentials : [];
  const submittedIds = existingCreds.map(c => c.system);
  const baseAccounts = assignedSystems.length > 0
    ? ACCOUNTS.filter(a => assignedSystems.includes(a.id))
    : ACCOUNTS;

  const [accounts, setAccounts] = useState(
    baseAccounts.map(a => ({ ...a, submitted: submittedIds.includes(a.id) }))
  );
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ email: '', password: '', notes: '' });
  const [submitted, setSubmitted] = useState(false);
  const [hasAccount, setHasAccount] = useState(null);

  useEffect(() => {
    if (!clientData || !clientData.credentials) return;
    const ids = clientData.credentials.map(c => c.system);
    setAccounts(prev => prev.map(a => ({ ...a, submitted: ids.includes(a.id) })));
  }, [clientData]);

  const openModal = (acct) => {
    setModal(acct);
    setForm({ email: '', password: '', notes: '' });
    setSubmitted(false);
    setHasAccount(null);
  };

  const handleSubmit = async () => {
    if (!form.email || !form.password) return;
    const clientId = clientData && clientData.id;
    if (clientId) {
      await supabase.from('credentials').upsert([{
        client_id: clientId,
        system: modal.id,
        username: form.email,
        password: form.password,
      }], { onConflict: 'client_id,system' });
      const result = await supabase.from('clients')
        .select('*, credentials:credentials(*), service_requests:service_requests(*), network_info')
        .eq('id', clientId).single();
      if (result.data && setClientData) setClientData(result.data);
    }
    setAccounts(prev => prev.map(a => a.id === modal.id ? { ...a, submitted: true } : a));
    setSubmitted(true);
  };

  const done = accounts.filter(a => a.submitted).length;

  return (
    <div>
              <button onClick={() => setView('overview')} style={{
          display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
          color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
          fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
          cursor:'pointer', padding:0, marginBottom:20, transition:'color 0.2s'
        }}
          onMouseOver={e => e.currentTarget.style.color='#111111'}
          onMouseOut={e => e.currentTarget.style.color='#777770'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Overview
        </button>
      <div className="content-header">
        <div className="content-eyebrow">Pre-Install Setup</div>
        <div className="content-title">Account Credentials</div>
        <div className="content-desc">
          Submit your login details for each system below. This allows our team to configure everything before arriving on site — saving hours on install day.<br/>
          <span style={{color:'#555550', marginTop:6, display:'block'}}>
            {done}/{accounts.length} accounts submitted
          </span>
        </div>
      </div>

      {done === accounts.length && (
        <div className="success-banner" style={{marginBottom:24}}>
          <div className="success-dot"/>
          <div className="success-text">All accounts submitted — your install team has everything they need. Thank you!</div>
        </div>
      )}

      <div className="setup-list">
        {accounts.map(acct => (
          <div key={acct.id} className="setup-item">
            <div className={`setup-item-check ${acct.submitted ? 'done' : ''}`}>
              {acct.submitted && <IconCheck/>}
            </div>
            <div className="setup-item-info">
              <div className="setup-item-name">{acct.name}</div>
              <div className="setup-item-desc">{acct.desc}</div>
            </div>
            <button
              className={`setup-item-btn ${acct.submitted ? 'submitted' : ''}`}
              onClick={() => openModal(acct)}
            >
              {acct.submitted ? '✓ Submitted' : 'Add Credentials'}
            </button>
          </div>
        ))}
      </div>

      {modal && (
        <div className="modal-overlay" onClick={() => setModal(null)}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setModal(null)}>×</button>
            {submitted ? (
              <div style={{textAlign:'center', padding:'20px 0'}}>
                <div style={{width:56, height:56, background:'rgba(229,0,0,0.1)', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', margin:'0 auto 20px', border:'1px solid rgba(229,0,0,0.3)'}}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#E50000" strokeWidth="2" width="24" height="24">
                    <path d="M20 6L9 17l-5-5"/>
                  </svg>
                </div>
                <div style={{fontFamily:'Cormorant Garamond, serif', fontSize:28, fontWeight:300, marginBottom:10}}>Credentials Saved</div>
                <div style={{fontSize:11, color:'#777770', lineHeight:1.7, marginBottom:24}}>Your {modal.name} credentials have been securely stored. Our team will use these to configure your system.</div>
                <button className="btn-primary" onClick={() => setModal(null)}>Done</button>
              </div>
            ) : hasAccount === null ? (
              <>
                <div className="modal-eyebrow">{modal.name}</div>
                <div className="modal-title">Do you already have an account?</div>
                <div className="modal-desc">Let us know so we can guide you through the right steps.</div>
                <div style={{display:'flex', flexDirection:'column', gap:10, marginTop:8}}>
                  <button onClick={() => setHasAccount(true)} style={{
                    background:'#FFFFFF', border:'1px solid #2a2a2a', borderRadius:2, padding:'16px 20px',
                    display:'flex', alignItems:'center', justifyContent:'space-between',
                    cursor:'pointer', transition:'border-color 0.2s', fontFamily:"'Montserrat', sans-serif"
                  }}
                    onMouseOver={e => e.currentTarget.style.borderColor='#E50000'}
                    onMouseOut={e => e.currentTarget.style.borderColor='#D4D1CE'}>
                    <div style={{textAlign:'left'}}>
                      <div style={{fontSize:12, fontWeight:600, color:'#111111', letterSpacing:'0.04em', marginBottom:3}}>Yes, I already have one</div>
                      <div style={{fontSize:11, color:'#777770'}}>I'll just enter my existing login</div>
                    </div>
                    <span style={{color:'#E50000', fontSize:16}}>→</span>
                  </button>
                  <button onClick={() => setHasAccount(false)} style={{
                    background:'#FFFFFF', border:'1px solid #2a2a2a', borderRadius:2, padding:'16px 20px',
                    display:'flex', alignItems:'center', justifyContent:'space-between',
                    cursor:'pointer', transition:'border-color 0.2s', fontFamily:"'Montserrat', sans-serif"
                  }}
                    onMouseOver={e => e.currentTarget.style.borderColor='#E50000'}
                    onMouseOut={e => e.currentTarget.style.borderColor='#D4D1CE'}>
                    <div style={{textAlign:'left'}}>
                      <div style={{fontSize:12, fontWeight:600, color:'#111111', letterSpacing:'0.04em', marginBottom:3}}>No, I need to create one</div>
                      <div style={{fontSize:11, color:'#777770'}}>I'll follow the setup steps first</div>
                    </div>
                    <span style={{color:'#E50000', fontSize:16}}>→</span>
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="modal-eyebrow">{modal.name}</div>
                <div className="modal-title">{hasAccount ? 'Submit Your Login' : 'Account Setup'}</div>

                {/* Installer Creates Account Banner */}
                {modal.installerCreates && (
                  <div style={{background:'rgba(229,0,0,0.08)', border:'1px solid rgba(229,0,0,0.25)', borderRadius:2, padding:'14px 18px', marginBottom:20, display:'flex', gap:12, alignItems:'flex-start'}}>
                    <div style={{fontSize:18, flexShrink:0}}>ℹ️</div>
                    <div>
                      <div style={{fontSize:10, fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase', color:'#E50000', marginBottom:4}}>Smart Tech Creates Your Account</div>
                      <div style={{fontSize:11, color:'#555550', lineHeight:1.7}}>You do not need to create an account for this app. Smart Tech Utah will set it up for you and you'll receive an email once it's ready. Simply provide the email address you'd like used below.</div>
                    </div>
                  </div>
                )}

                {/* Step 1 - Download & Create Account (only if they need to create + app/web exists) */}
                {!hasAccount && (modal.ios || modal.android || modal.web) && (
                  <div style={{background:'#F8F5F2', border:'1px solid #2a2a2a', borderRadius:2, padding:'18px 20px', marginBottom:20}}>
                    <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:10}}>
                      <div style={{width:20, height:20, background:'#E50000', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, color:'#fff', flexShrink:0}}>1</div>
                      <span style={{fontSize:10, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:'#111111'}}>{modal.web && !modal.ios && !modal.android ? 'Create Account Online' : 'Download & Create Account'}</span>
                    </div>
                    <p style={{fontSize:11, color:'#777770', lineHeight:1.7, marginBottom:14}}>{modal.instructions}</p>
                    <div style={{display:'flex', gap:10, flexWrap:'wrap'}}>
                      {modal.web && !modal.ios && !modal.android && (
                        <a href={modal.web} target="_blank" rel="noreferrer" style={{display:'flex', alignItems:'center', gap:7, background:'#EEEBE7', border:'1px solid #2a2a2a', borderRadius:2, padding:'8px 16px', textDecoration:'none', transition:'border-color 0.2s'}}
                          onMouseOver={e => e.currentTarget.style.borderColor='#E50000'}
                          onMouseOut={e => e.currentTarget.style.borderColor='#D4D1CE'}>
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="14" height="14" style={{color:'#111111'}}>
                            <circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/>
                          </svg>
                          <span style={{fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:'#111111'}}>{modal.webLabel || 'Create Account'}</span>
                        </a>
                      )}
                      {modal.ios && (
                        <a href={modal.ios} target="_blank" rel="noreferrer" style={{display:'flex', alignItems:'center', gap:7, background:'#EEEBE7', border:'1px solid #2a2a2a', borderRadius:2, padding:'8px 14px', textDecoration:'none', transition:'border-color 0.2s'}}
                          onMouseOver={e => e.currentTarget.style.borderColor='#E50000'}
                          onMouseOut={e => e.currentTarget.style.borderColor='#D4D1CE'}>
                          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{color:'#111111'}}>
                            <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                          </svg>
                          <span style={{fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:'#111111'}}>App Store</span>
                        </a>
                      )}
                      {modal.android && (
                        <a href={modal.android} target="_blank" rel="noreferrer" style={{display:'flex', alignItems:'center', gap:7, background:'#EEEBE7', border:'1px solid #2a2a2a', borderRadius:2, padding:'8px 14px', textDecoration:'none', transition:'border-color 0.2s'}}
                          onMouseOver={e => e.currentTarget.style.borderColor='#E50000'}
                          onMouseOut={e => e.currentTarget.style.borderColor='#D4D1CE'}>
                          <svg viewBox="0 0 24 24" fill="currentColor" width="14" height="14" style={{color:'#111111'}}>
                            <path d="M17.523 15.3414c-.5511 0-.9993-.4486-.9993-.9997s.4483-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993.0001.5511-.4482.9997-.9993.9997m-11.046 0c-.5511 0-.9993-.4486-.9993-.9997s.4482-.9993.9993-.9993c.5511 0 .9993.4483.9993.9993 0 .5511-.4483.9997-.9993.9997m11.4045-6.02l1.9973-3.4592a.416.416 0 00-.1521-.5676.416.416 0 00-.5676.1521l-2.0223 3.503C15.5902 8.2439 13.8533 7.8508 12 7.8508s-3.5902.3931-5.1367 1.0989L4.841 5.4467a.4161.4161 0 00-.5677-.1521.4157.4157 0 00-.1521.5676l1.9973 3.4592C2.6889 11.1867.3432 14.6589 0 18.761h24c-.3435-4.1021-2.6892-7.5743-6.1185-9.4396"/>
                          </svg>
                          <span style={{fontSize:10, fontWeight:600, letterSpacing:'0.1em', textTransform:'uppercase', color:'#111111'}}>Google Play</span>
                        </a>
                      )}
                    </div>
                  </div>
                )}

                {/* Step 2 - Submit Credentials */}
                <div style={{background:'#F8F5F2', border:'1px solid #2a2a2a', borderRadius:2, padding:'18px 20px', marginBottom:20}}>
                  <div style={{display:'flex', alignItems:'center', gap:8, marginBottom:10}}>
                    <div style={{width:20, height:20, background:'#E50000', borderRadius:'50%', display:'flex', alignItems:'center', justifyContent:'center', fontSize:10, fontWeight:700, color:'#fff', flexShrink:0}}>{hasAccount ? '1' : (modal.ios || modal.android || modal.web) ? '2' : '1'}</div>
                    <span style={{fontSize:10, fontWeight:600, letterSpacing:'0.14em', textTransform:'uppercase', color:'#111111'}}>Submit Your Login</span>
                  </div>
                  {(!modal.ios && !modal.android && !modal.web) && (
                    <p style={{fontSize:11, color:'#777770', lineHeight:1.7, marginBottom:14}}>{modal.instructions}</p>
                  )}
                  <div className="form-group" style={{marginBottom:14}}>
                    <label className="form-label">Email Address or Username</label>
                    <input className="form-input" type="text" placeholder="your@email.com or username" value={form.email} onChange={e => setForm(p => ({...p, email: e.target.value}))}/>
                  </div>
                  <div className="form-group" style={{marginBottom:14}}>
                    <label className="form-label">Password</label>
                    <input className="form-input" type="password" placeholder="••••••••••" value={form.password} onChange={e => setForm(p => ({...p, password: e.target.value}))}/>
                    <div className="form-note"><IconLock/> Stored with end-to-end encryption</div>
                  </div>
                  <div className="form-group" style={{marginBottom:0}}>
                    <label className="form-label">Notes (optional)</label>
                    <input className="form-input" placeholder="e.g. 2FA sent to 801-xxx-xxxx" value={form.notes} onChange={e => setForm(p => ({...p, notes: e.target.value}))}/>
                  </div>
                </div>

                <button className="btn-primary" onClick={handleSubmit}>Submit Credentials</button>
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

function DevicesView({ setView, clientData }) {
  const [devices, setDevices] = useState([]);
  useEffect(() => {
    if (!clientData?.id) return;
    supabase.from('devices').select('*').eq('client_id', clientData.id).order('created_at')
      .then(({ data }) => { if (data) setDevices(data); });
  }, [clientData?.id]);
  return (
    <div>
              <button onClick={() => setView('overview')} style={{
          display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
          color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
          fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
          cursor:'pointer', padding:0, marginBottom:20, transition:'color 0.2s'
        }}
          onMouseOver={e => e.currentTarget.style.color='#111111'}
          onMouseOut={e => e.currentTarget.style.color='#777770'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Overview
        </button>
      <div className="content-header">
        <div className="content-eyebrow">Installed Equipment</div>
        <div className="content-title">Your System</div>
        <div className="content-desc">Every device installed in your home. Click any device to access its manual or documentation.</div>
      </div>
      {devices.length === 0 && <div style={{color:'#999990',fontSize:12,padding:'20px 0'}}>No devices have been added yet.</div>}
      {['Networking','Audio','Video','Lighting','Security','Access Control','Climate','Other'].map(cat => {
        const catDevices = devices.filter(d => d.category === cat);
        if (catDevices.length === 0) return null;
        return (
          <div key={cat} style={{marginBottom:24}}>
            <div style={{fontSize:9,color:'#777770',textTransform:'uppercase',letterSpacing:'0.12em',marginBottom:12,paddingBottom:8,borderBottom:'1px solid #1a1a1a'}}>{cat}</div>
            <div className="device-grid">
              {catDevices.map(d => (
                <div key={d.id} className="device-card">
                  <div className="device-room">{d.category}</div>
                  <div className="device-brand">{d.make}</div>
                  <div className="device-model">{d.model}</div>
                  {d.manual_url ? (
                    <a href={d.manual_url} target="_blank" rel="noreferrer" className="device-manual" style={{textDecoration:'none',display:'flex',alignItems:'center',gap:6}}>
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" width="12" height="12">
                        <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/>
                        <path d="M14 2v6h6"/>
                      </svg>
                      View Manual
                    </a>
                  ) : (
                    <div className="device-manual" style={{opacity:0.3}}>No Manual</div>
                  )}
                </div>
              ))}
            </div>
          </div>
        );
      })}
      {devices.filter(d=>!d.category).map(d => (
        <div key={d.id} className="device-card">
          <div className="device-brand">{d.make}</div>
          <div className="device-model">{d.model}</div>
        </div>
      ))}
    </div>
  );
}

function DocsView({ setView, clientData }) {
  const [documents, setDocuments] = useState([]);
  const [devices, setDevices] = useState([]);
  const [activeDoc, setActiveDoc] = useState(null);

  useEffect(() => {
    if (!clientData?.id) return;
    const load = async () => {
      const [{ data: docs }, { data: devs }] = await Promise.all([
        supabase.from('documents').select('*').eq('client_id', clientData.id).order('created_at'),
        supabase.from('devices').select('*').eq('client_id', clientData.id).order('created_at'),
      ]);
      if (docs) setDocuments(docs);
      if (devs) setDevices(devs.filter(d => d.manual_url));
    };
    load();
  }, [clientData?.id]);

  const tagColors = { Network:'#1a3a5c', Warranty:'#3a1a1a', Manual:'#1a3a2a', Installation:'#2a2a1a', General:'#EEEBE7' };

  const allFiles = [
    ...documents.map(d => ({ name: d.name, url: d.url, tag: d.category || 'General' })),
    ...devices.map(d => ({ name: `${d.make} ${d.model} — Manual`, url: d.manual_url, tag: 'Manual' })),
  ];

  if (activeDoc) {
    return (
      <div>
        <button onClick={() => setActiveDoc(null)} style={{
          display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
          color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
          fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
          cursor:'pointer', padding:0, marginBottom:20
        }}
          onMouseOver={e => e.currentTarget.style.color='#111111'}
          onMouseOut={e => e.currentTarget.style.color='#777770'}>
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Documents
        </button>
        <div style={{marginBottom:16}}>
          <div style={{fontSize:10,color:'#777770',textTransform:'uppercase',letterSpacing:'0.12em',marginBottom:4}}>{activeDoc.tag}</div>
          <div style={{fontSize:20,color:'#111111',fontFamily:"'Cormorant Garamond', serif"}}>{activeDoc.name}</div>
        </div>
        <div style={{width:'100%',height:'75vh',border:'1px solid #1a1a1a',borderRadius:4,overflow:'hidden',background:'#F8F5F2'}}>
          <iframe src={activeDoc.url} title={activeDoc.name} style={{width:'100%',height:'100%',border:'none'}}/>
        </div>
        <div style={{marginTop:12,textAlign:'right'}}>
          <a href={activeDoc.url} target="_blank" rel="noreferrer"
            style={{fontSize:10,color:'#777770',textDecoration:'none',letterSpacing:'0.06em',textTransform:'uppercase'}}>
            Open in new tab →
          </a>
        </div>
      </div>
    );
  }

  return (
    <div>
      <button onClick={() => setView('overview')} style={{
          display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
          color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
          fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
          cursor:'pointer', padding:0, marginBottom:20, transition:'color 0.2s'
        }}
          onMouseOver={e => e.currentTarget.style.color='#111111'}
          onMouseOut={e => e.currentTarget.style.color='#777770'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Overview
        </button>
      <div className="content-header">
        <div className="content-eyebrow">Network & Documents</div>
        <div className="content-title">Network / WiFi</div>
        <div className="content-desc">Your home network credentials and any documents related to your installation.</div>
      </div>
      {/* WiFi Info */}
      {clientData && clientData.network_info && clientData.network_info.ssid && (
        <div style={{marginBottom:28}}>
          <div style={{fontSize:9,color:'#777770',textTransform:'uppercase',letterSpacing:'0.12em',marginBottom:12}}>WiFi Network</div>
          <div style={{background:'#FFFFFF',border:'1px solid #1a1a1a',borderRadius:4,padding:20,marginBottom:12}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
              <span style={{fontSize:11,color:'#777770'}}>Network Name</span>
              <span style={{fontSize:11,color:'#111111',fontWeight:600}}>{clientData.network_info.ssid}</span>
            </div>
            {clientData.network_info.wifi_password && (
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <span style={{fontSize:11,color:'#777770'}}>Password</span>
                <span style={{fontSize:11,color:'#111111',fontFamily:'monospace',letterSpacing:'0.06em'}}>{clientData.network_info.wifi_password}</span>
              </div>
            )}
          </div>
          {clientData.network_info.router_ip && (
            <div style={{background:'#FFFFFF',border:'1px solid #1a1a1a',borderRadius:4,padding:20}}>
              <div style={{display:'flex',justifyContent:'space-between'}}>
                <span style={{fontSize:11,color:'#777770'}}>Router IP</span>
                <span style={{fontSize:11,color:'#111111',fontFamily:'monospace'}}>{clientData.network_info.router_ip}</span>
              </div>
            </div>
          )}
          {clientData.network_info.notes && (
            <div style={{marginTop:12,fontSize:11,color:'#888880',lineHeight:1.7}}>{clientData.network_info.notes}</div>
          )}
        </div>
      )}

      {allFiles.length > 0 && (
        <div style={{fontSize:9,color:'#777770',textTransform:'uppercase',letterSpacing:'0.12em',marginBottom:12}}>Documents</div>
      )}
      <div className="doc-list">
        {allFiles.length === 0 && !(clientData && clientData.network_info && clientData.network_info.ssid) && (
          <div style={{color:'#999990',fontSize:12,padding:'20px 0'}}>No documents available yet.</div>
        )}
        {allFiles.map((doc, i) => (
          <div key={i} className="doc-item" style={{cursor:'pointer'}} onClick={() => setActiveDoc(doc)}>
            <div className="doc-icon" style={{
              background: tagColors[doc.tag] || '#EEEBE7',
              color: '#E50000',
              fontSize:8, fontWeight:700, letterSpacing:'0.06em',
              padding:'4px 6px', borderRadius:2, minWidth:36, textAlign:'center',
              border:'1px solid #2a2a2a'
            }}>
              {doc.tag==='Network'?'NET':doc.tag==='Warranty'?'WAR':doc.tag==='Manual'?'MAN':doc.tag==='Installation'?'INST':'PDF'}
            </div>
            <div className="doc-info">
              <div className="doc-name">{doc.name}</div>
              <div className="doc-meta">{doc.tag}</div>
            </div>
            <IconArrow/>
          </div>
        ))}
      </div>
    </div>
  );
}

function SupportView({ setView, clientData }) {
  const [form, setForm] = useState({ system: '', priority: '', message: '' });
  const [sent, setSent] = useState(false);
  const [requests, setRequests] = useState([]);
  const [expanded, setExpanded] = useState(null);
  const [showForm, setShowForm] = useState(false);
  const [clientReplies, setClientReplies] = useState({});

  const loadRequests = async () => {
    if (!clientData?.id) return;
    const { data } = await supabase
      .from('service_requests')
      .select('*')
      .eq('client_id', clientData.id)
      .order('created_at', { ascending: false });
    if (data) {
      setRequests(data);
      const unread = data.filter(r => !r.resolved && !r.last_read_client);
      for (const r of unread) {
        await supabase.from("service_requests").update({ last_read_client: new Date().toISOString() }).eq("id", r.id);
      }
    }
  };

  useEffect(() => { loadRequests(); }, [clientData, sent]);

  const handleSubmit = async () => {
    if (!form.system || !form.message) return;
    if (!clientData?.id) return;
    const thread = [{ from: 'client', text: form.message, time: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }];
    await supabase.from('service_requests').insert([{
      client_id: clientData.id,
      subject: form.system,
      message: form.message,
      priority: form.priority || 'normal',
      resolved: false,
      thread,
    }]);
    setSent(true);
    setShowForm(false);
    setForm({ system: '', priority: '', message: '' });
  };

  const handleClientReply = async (req) => {
    const text = (clientReplies[req.id] || '').trim();
    if (!text) return;
    const newMsg = { from: 'client', text, time: new Date().toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) };
    const currentThread = req.thread || [{ from: 'client', text: req.message, time: new Date(req.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }];
    const updated = [...currentThread, newMsg];
    await supabase.from('service_requests').update({ thread: updated }).eq('id', req.id);
    setClientReplies(p => ({ ...p, [req.id]: '' }));
    loadRequests();
  };

  return (
    <div>
      <button onClick={() => setView('overview')} style={{
        display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
        color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
        fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
        cursor:'pointer', padding:0, marginBottom:20, transition:'color 0.2s'
      }}
        onMouseOver={e => e.currentTarget.style.color='#111111'}
        onMouseOut={e => e.currentTarget.style.color='#777770'}
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
          <path d="M19 12H5M12 5l-7 7 7 7"/>
        </svg>
        Back to Overview
      </button>

      <div className="content-header">
        <div className="content-eyebrow">Smart Tech Utah</div>
        <div className="content-title">Service Requests</div>
        <div className="content-desc">Submit a support request or view your request history below.</div>
      </div>

      {sent && (
        <div className="success-banner" style={{marginBottom:24}}>
          <div className="success-dot"/>
          <div className="success-text">Your request has been submitted. Chad will be in touch shortly.</div>
        </div>
      )}

      <button className="btn-primary" style={{marginBottom:24, maxWidth:220}} onClick={() => { setShowForm(!showForm); setSent(false); }}>
        {showForm ? 'Cancel' : '+ New Service Request'}
      </button>

      {showForm && (
        <div className="service-form" style={{marginBottom:32}}>
          <div className="form-group">
            <label className="form-label">Affected System</label>
            <select className="form-select" value={form.system} onChange={e => setForm(p => ({...p, system: e.target.value}))}>
              <option value="">Select a system...</option>
              <option>Sonos — Audio</option>
              <option>Lutron — Lighting</option>
              <option>Josh AI — Automation</option>
              <option>ICRealtime — Cameras</option>
              <option>Alarm.com — Security</option>
              <option>UniFi Access — Doors</option>
              <option>Samsung — TV</option>
              <option>Denon HEOS — Audio</option>
              <option>DoorBird — Doorbell</option>
              <option>Home Theater</option>
              <option>Networking / Wi-Fi</option>
              <option>Other</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Priority</label>
            <select className="form-select" value={form.priority} onChange={e => setForm(p => ({...p, priority: e.target.value}))}>
              <option value="">Select priority...</option>
              <option>Low — Not urgent</option>
              <option>Medium — Needs attention soon</option>
              <option>High — System is down</option>
            </select>
          </div>
          <div className="form-group">
            <label className="form-label">Describe the Issue</label>
            <textarea className="form-textarea" placeholder="Tell us what's happening..." value={form.message} onChange={e => setForm(p => ({...p, message: e.target.value}))}/>
          </div>
          <button className="btn-primary" onClick={handleSubmit}>Submit Request</button>
        </div>
      )}

      {requests.length === 0 && !showForm && (
        <div style={{color:'#888880', fontSize:13}}>No service requests yet.</div>
      )}

      <div style={{display:'flex', flexDirection:'column', gap:12}}>
        {requests.map(req => {
          const thread = req.thread && req.thread.length > 0
            ? req.thread
            : [{ from: 'client', text: req.message, time: new Date(req.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' }) }];
          return (
            <div key={req.id} style={{background:'#FFFFFF', border:'1px solid #1e1e1e', borderRadius:2, overflow:'hidden'}}>
              <div
                onClick={() => setExpanded(expanded === req.id ? null : req.id)}
                style={{padding:'14px 16px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'space-between'}}
              >
                <div>
                  <div style={{fontSize:13, color:'#111111', marginBottom:4}}>{req.subject}</div>
                  <div style={{fontSize:10, color:'#888880', letterSpacing:'0.06em'}}>
                    {new Date(req.created_at).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'})}
                    {req.resolved && req.resolved_at && ` · Resolved ${new Date(req.resolved_at).toLocaleDateString('en-US', {month:'short', day:'numeric', year:'numeric'})}`}
                  </div>
                </div>
                <div style={{display:'flex', alignItems:'center', gap:8}}>
                  <span style={{
                    fontSize:9, fontWeight:700, letterSpacing:'0.1em', textTransform:'uppercase',
                    color: req.resolved ? '#999990' : '#E50000',
                    background: req.resolved ? '#EEEBE7' : '#1a0000',
                    padding:'3px 8px', borderRadius:2
                  }}>
                    {req.resolved ? 'Resolved' : 'Open'}
                  </span>
                  <svg viewBox="0 0 24 24" fill="none" stroke="#888880" strokeWidth="2" width="12" height="12"
                    style={{transform: expanded === req.id ? 'rotate(180deg)' : 'rotate(0deg)', transition:'transform 0.2s'}}>
                    <path d="M6 9l6 6 6-6"/>
                  </svg>
                </div>
              </div>

              {expanded === req.id && (
                <div style={{borderTop:'1px solid #1e1e1e'}}>
                  <div style={{padding:'12px 0'}}>
                    {thread.map((msg, i) => (
                      <div key={i} style={{padding:'10px 16px', borderBottom: i < thread.length-1 ? '1px solid #111' : 'none'}}>
                        <div style={{display:'flex', justifyContent:'space-between', marginBottom:4}}>
                          <span style={{
                            fontSize:9, fontWeight:700, letterSpacing:'0.12em', textTransform:'uppercase',
                            color: msg.from === 'installer' ? '#E50000' : '#777770'
                          }}>
                            {msg.from === 'installer' ? 'Smart Tech Utah' : 'You'}
                          </span>
                          <span style={{fontSize:9, color:'#D4D1CE'}}>{msg.time}</span>
                        </div>
                        <div style={{fontSize:12, color:'#555550', lineHeight:1.7}}>{msg.text}</div>
                      </div>
                    ))}
                  </div>
                  {!req.resolved && (
                    <div style={{padding:'12px 16px', borderTop:'1px solid #1e1e1e'}}>
                      <textarea
                        className="form-textarea"
                        placeholder="Reply to Smart Tech Utah..."
                        value={clientReplies[req.id] || ''}
                        onChange={e => setClientReplies(p => ({ ...p, [req.id]: e.target.value }))}
                        style={{minHeight:70, marginBottom:8}}
                      />
                      <button className="btn-primary" style={{maxWidth:160}} onClick={() => handleClientReply(req)}>
                        Send Reply
                      </button>
                    </div>
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
function UpgradeView({ setView }) {
  const [selected, setSelected] = useState(null);
  const [sent, setSent] = useState(false);

  return (
    <div>
              <button onClick={() => setView('overview')} style={{
          display:'flex', alignItems:'center', gap:6, background:'none', border:'none',
          color:'#777770', fontFamily:"'Montserrat', sans-serif", fontSize:10,
          fontWeight:600, letterSpacing:'0.12em', textTransform:'uppercase',
          cursor:'pointer', padding:0, marginBottom:20, transition:'color 0.2s'
        }}
          onMouseOver={e => e.currentTarget.style.color='#111111'}
          onMouseOut={e => e.currentTarget.style.color='#777770'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="12" height="12">
            <path d="M19 12H5M12 5l-7 7 7 7"/>
          </svg>
          Back to Overview
        </button>
      <div className="content-header">
        <div className="content-eyebrow">Elevate Your System</div>
        <div className="content-title">Add to Your Home</div>
        <div className="content-desc">Explore upgrades and additions for your Smart Tech Utah system. Request a quote and Chad will be in touch.</div>
      </div>

      {sent ? (
        <div className="success-banner" style={{maxWidth:500}}>
          <div className="success-dot"/>
          <div className="success-text">Your upgrade inquiry has been sent. We'll reach out to discuss options and pricing.</div>
        </div>
      ) : (
        <>
          <div className="upgrade-grid" style={{marginBottom:28}}>
            {UPGRADES.map((u, i) => (
              <div
                key={i}
                className="upgrade-card"
                style={selected === i ? {borderColor:'#E50000', background:'#131313'} : {}}
                onClick={() => setSelected(selected === i ? null : i)}
              >
                <div className="upgrade-icon">{u.icon}</div>
                <div className="upgrade-title">{u.title}</div>
                <div className="upgrade-desc">{u.desc}</div>
                <div className="upgrade-cta">{selected === i ? '✓ Selected' : 'Learn More →'}</div>
              </div>
            ))}
          </div>
          {selected !== null && (
            <div style={{maxWidth:480}}>
              <div style={{fontSize:11, color:'#777770', marginBottom:16, letterSpacing:'0.04em'}}>
                Requesting quote for: <span style={{color:'#111111', fontWeight:500}}>{UPGRADES[selected].title}</span>
              </div>
              <button className="btn-primary" onClick={() => setSent(true)}>
                Request a Quote
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}

// --- LOGIN SCREEN ---
// PIN helpers for client portal
const CP_PIN_KEY = 'st_client_pin';
const cpHashPin = async (pin, email) => {
  const data = new TextEncoder().encode(pin + email + 'smarttech_salt_client');
  const buf = await crypto.subtle.digest('SHA-256', data);
  return Array.from(new Uint8Array(buf)).map(b => b.toString(16).padStart(2,'0')).join('');
};
const cpSavePin = async (pin, email) => {
  const hash = await cpHashPin(pin, email);
  localStorage.setItem(CP_PIN_KEY, JSON.stringify({ hash, email }));
};
const cpGetPin = () => { try { return JSON.parse(localStorage.getItem(CP_PIN_KEY)); } catch { return null; } };
const cpClearPin = () => localStorage.removeItem(CP_PIN_KEY);

function ClientPinUnlockScreen({ onUnlock, onSignOut }) {
  const [pin, setPin] = useState('');
  const [pinError, setPinError] = useState('');
  const [loading, setLoading] = useState(false);
  const savedPin = cpGetPin();

  const handlePinCheck = async (p) => {
    if (p.length !== 4) return;
    setLoading(true);
    const hash = await cpHashPin(p, savedPin.email);
    if (hash === savedPin.hash) {
      onUnlock();
    } else {
      setPinError('Incorrect PIN');
      setPin('');
    }
    setLoading(false);
  };

  const pinBoxStyle = {width:56,height:64,background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:4,display:'flex',alignItems:'center',justifyContent:'center',fontSize:28,fontWeight:700,color:'#111111'};

  return (
    <>
      <style>{styles}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
        <div style={{width:380,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:28}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:52,maxWidth:260,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontSize:11,color:'#777770',letterSpacing:'0.08em'}}>Enter your PIN to continue</div>
          </div>
          <div style={{display:'flex',justifyContent:'center',gap:12,marginBottom:24}}>
            {[0,1,2,3].map(i => (
              <div key={i} style={{...pinBoxStyle, borderColor: pin.length > i ? '#E50000' : '#D4D1CE'}}>
                {pin.length > i ? '●' : ''}
              </div>
            ))}
          </div>
          <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:8,marginBottom:16}}>
            {[1,2,3,4,5,6,7,8,9,'',0,'⌫'].map((n,i) => (
              <button key={i} onClick={() => {
                if(n==='⌫') setPin(p=>p.slice(0,-1));
                else if(n!=='') { const v=(pin+n).slice(0,4); setPin(v); if(v.length===4) handlePinCheck(v); }
              }} style={{padding:'14px',fontSize:18,fontWeight:500,background:n===''?'transparent':'#EEEBE7',border:'1px solid',borderColor:n===''?'transparent':'#D4D1CE',borderRadius:4,cursor:n===''?'default':'pointer',color:'#111111'}}>
                {n}
              </button>
            ))}
          </div>
          {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12,textAlign:'center'}}>{pinError}</div>}
          <button onClick={() => { cpClearPin(); onSignOut(); }} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center'}}>
            Sign out & use password
          </button>
        </div>
      </div>
    </>
  );
}

function ChangePinModal({ email, onClose }) {
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [pinError, setPinError] = useState('');
  const [saved, setSaved] = useState(false);

  const handleSave = async () => {
    if (newPin.length !== 4) { setPinError('PIN must be 4 digits'); return; }
    if (newPin !== confirmPin) { setPinError('PINs do not match'); return; }
    await cpSavePin(newPin, email);
    setSaved(true);
    setTimeout(() => onClose(), 1200);
  };

  const inputStyle = {width:'100%',boxSizing:'border-box',background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:3,padding:'10px 12px',color:'#111111',fontSize:13,outline:'none'};

  return (
    <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:300}} onClick={onClose}>
      <div style={{background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4,padding:32,width:340,maxWidth:'90vw'}} onClick={e => e.stopPropagation()}>
        <div style={{fontSize:14,fontWeight:600,color:'#111111',marginBottom:6}}>{saved ? '✓ PIN Updated' : 'Change PIN'}</div>
        {saved ? (
          <div style={{fontSize:12,color:'#22c55e',marginTop:8}}>Your new PIN has been saved.</div>
        ) : (
          <>
            <div style={{fontSize:11,color:'#777770',marginBottom:20,lineHeight:1.6}}>Enter a new 4-digit PIN. This replaces your current PIN.</div>
            <div style={{marginBottom:14}}>
              <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>New PIN</div>
              <input type="password" inputMode="numeric" maxLength={4} value={newPin} onChange={e => setNewPin(e.target.value.replace(/\D/g,'').slice(0,4))} style={inputStyle} placeholder="••••"/>
            </div>
            <div style={{marginBottom:16}}>
              <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>Confirm PIN</div>
              <input type="password" inputMode="numeric" maxLength={4} value={confirmPin} onChange={e => setConfirmPin(e.target.value.replace(/\D/g,'').slice(0,4))} style={inputStyle} placeholder="••••"/>
            </div>
            {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12}}>{pinError}</div>}
            <div style={{display:'flex',gap:10}}>
              <button onClick={handleSave} style={{flex:1,background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'10px',fontSize:11,fontWeight:700,letterSpacing:'0.08em',textTransform:'uppercase',cursor:'pointer'}}>Save PIN</button>
              <button onClick={() => { cpClearPin(); onClose(); }} style={{background:'transparent',border:'1px solid #D4D1CE',color:'#888880',borderRadius:3,padding:'10px 14px',fontSize:11,cursor:'pointer'}}>Remove PIN</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function ClientPinSetupScreen({ email, onDone }) {
  const [newPin, setNewPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [pinError, setPinError] = useState('');

  const handleSavePin = async () => {
    if (newPin.length !== 4) { setPinError('PIN must be 4 digits'); return; }
    if (newPin !== confirmPin) { setPinError('PINs do not match'); return; }
    await cpSavePin(newPin, email);
    onDone();
  };

  const inputStyle = {width:'100%',boxSizing:'border-box',background:'#EEEBE7',border:'1px solid #D4D1CE',borderRadius:3,padding:'10px 12px',color:'#111111',fontSize:13,outline:'none'};

  return (
    <>
      <style>{styles}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
        <div style={{width:380,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:28}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:52,maxWidth:260,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontSize:14,fontWeight:600,color:'#111111',marginBottom:6}}>Set Up a PIN</div>
            <div style={{fontSize:11,color:'#777770',lineHeight:1.6}}>Create a 4-digit PIN for faster sign-in next time.</div>
          </div>
          <div style={{marginBottom:16}}>
            <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>New PIN</div>
            <input type="password" inputMode="numeric" maxLength={4} value={newPin} onChange={e => setNewPin(e.target.value.replace(/\D/g,'').slice(0,4))} style={inputStyle} placeholder="••••"/>
          </div>
          <div style={{marginBottom:20}}>
            <div style={{fontSize:10,letterSpacing:'0.1em',color:'#777770',textTransform:'uppercase',marginBottom:6}}>Confirm PIN</div>
            <input type="password" inputMode="numeric" maxLength={4} value={confirmPin} onChange={e => setConfirmPin(e.target.value.replace(/\D/g,'').slice(0,4))} style={inputStyle} placeholder="••••"/>
          </div>
          {pinError && <div style={{color:'#E50000',fontSize:12,marginBottom:12,textAlign:'center'}}>{pinError}</div>}
          <button onClick={handleSavePin} style={{width:'100%',background:'#E50000',color:'#fff',border:'none',borderRadius:3,padding:'12px',fontSize:12,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',cursor:'pointer',marginBottom:10}}>
            Save PIN & Continue
          </button>
          <button onClick={onDone} style={{width:'100%',background:'transparent',border:'none',color:'#888880',fontSize:11,cursor:'pointer',textAlign:'center'}}>
            Skip for now
          </button>
        </div>
      </div>
    </>
  );
}

function ClientLoginScreen({ onLoggedIn }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [resetSent, setResetSent] = useState(false);
  const [showPinSetup, setShowPinSetup] = useState(false);

  const handleLogin = async () => {
    setLoading(true);
    setError('');
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    if (error) { setError('Invalid email or password. Check your invite email to set your password.'); setLoading(false); return; }
    setShowPinSetup(true);
    setLoading(false);
  };

  const handleReset = async () => {
    if (!email) { setError('Enter your email above first'); return; }
    await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin + '/portal' });
    setResetSent(true);
  };

  if (showPinSetup) return <ClientPinSetupScreen email={email} onDone={() => onLoggedIn()} />;

  return (
    <>
      <style>{styles}</style>
      <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',padding:24}}>
        <div style={{width:380,padding:'48px 40px',background:'#FFFFFF',border:'1px solid #D4D1CE',borderRadius:4}}>
          <div style={{textAlign:'center',marginBottom:36}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:52,maxWidth:260,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
            <div style={{fontFamily:"'Montserrat',sans-serif",fontSize:10,letterSpacing:"0.2em",color:"#777770",textTransform:"uppercase",marginTop:8}}>Client Portal</div>
          </div>
          {resetSent ? (
            <div style={{textAlign:"center",color:"#22c55e",fontSize:13,lineHeight:1.6}}>
              Check your email for a password reset link.
            </div>
          ) : (
            <>
              <div style={{marginBottom:16}}>
                <div style={{fontSize:10,letterSpacing:"0.1em",color:"#777770",textTransform:"uppercase",marginBottom:6}}>Email</div>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()}
                  style={{width:"100%",boxSizing:"border-box",background:"#EEEBE7",border:"1px solid #D4D1CE",borderRadius:3,padding:"10px 12px",color:"#111111",fontSize:13,outline:"none"}}/>
              </div>
              <div style={{marginBottom:24}}>
                <div style={{fontSize:10,letterSpacing:"0.1em",color:"#777770",textTransform:"uppercase",marginBottom:6}}>Password</div>
                <input type="password" value={password} onChange={e => setPassword(e.target.value)} onKeyDown={e => e.key === "Enter" && handleLogin()}
                  style={{width:"100%",boxSizing:"border-box",background:"#EEEBE7",border:"1px solid #D4D1CE",borderRadius:3,padding:"10px 12px",color:"#111111",fontSize:13,outline:"none"}}/>
              </div>
              {error && <div style={{color:"#E50000",fontSize:12,marginBottom:16,textAlign:"center",lineHeight:1.5}}>{error}</div>}
              <button onClick={handleLogin} disabled={loading}
                style={{width:"100%",background:"#E50000",color:"#fff",border:"none",borderRadius:3,padding:"12px",fontSize:12,fontWeight:700,letterSpacing:"0.1em",textTransform:"uppercase",cursor:"pointer",marginBottom:16}}>
                {loading ? "Signing in..." : "Sign In"}
              </button>
              <div style={{textAlign:"center"}}>
                <button onClick={handleReset} style={{background:"none",border:"none",color:"#777770",fontSize:11,cursor:"pointer",textDecoration:"underline"}}>
                  Forgot password / first time setup
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

// --- MAIN APP ---
function SetPasswordScreen() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const handleSetPassword = async () => {
    if (password.length < 8) { setError('Password must be at least 8 characters'); return; }
    if (password !== confirm) { setError('Passwords do not match'); return; }
    setLoading(true);
    const { error } = await supabase.auth.updateUser({ password });
    if (error) { setError(error.message); setLoading(false); }
    else { setDone(true); }
  };

  if (done) return (
    <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center'}}>
      <div style={{textAlign:'center',color:'#111111'}}>
        <div style={{fontSize:16,fontWeight:600,marginBottom:8}}>Password Set!</div>
        <div style={{fontSize:12,color:'#777770'}}>Redirecting to your portal...</div>
      </div>
    </div>
  );

  return (
    <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',padding:'0 20px'}}>
      <div style={{width:'100%',maxWidth:400}}>
        <div style={{textAlign:'center',marginBottom:32}}>
          <img src={LOGO_B64} alt="Smart Tech" style={{height:52,maxWidth:260,objectFit:'contain',marginBottom:16,mixBlendMode:'multiply'}}/>
          <div style={{fontSize:20,fontWeight:700,color:'#111111',letterSpacing:'0.05em'}}>Welcome to Your Portal</div>
          <div style={{fontSize:12,color:'#777770',marginTop:8}}>Create a password to access your Smart Tech portal</div>
        </div>
        <div style={{background:'#FFFFFF',border:'1px solid #2a2a2a',borderRadius:4,padding:32}}>
          <input type="password" placeholder="New password" value={password} onChange={e => setPassword(e.target.value)}
            style={{width:'100%',background:'#F8F5F2',border:'1px solid #2a2a2a',borderRadius:2,padding:'10px 14px',color:'#111111',fontSize:13,marginBottom:12,boxSizing:'border-box'}}/>
          <input type="password" placeholder="Confirm password" value={confirm} onChange={e => setConfirm(e.target.value)}
            onKeyDown={e => e.key === 'Enter' && handleSetPassword()}
            style={{width:'100%',background:'#F8F5F2',border:'1px solid #2a2a2a',borderRadius:2,padding:'10px 14px',color:'#111111',fontSize:13,marginBottom:16,boxSizing:'border-box'}}/>
          {error && <div style={{color:'#E50000',fontSize:11,marginBottom:12}}>{error}</div>}
          <button onClick={handleSetPassword} disabled={loading}
            style={{width:'100%',background:'#E50000',color:'#fff',border:'none',borderRadius:2,padding:'12px',fontSize:12,fontWeight:700,letterSpacing:'0.1em',textTransform:'uppercase',cursor:'pointer'}}>
            {loading ? 'Setting Password...' : 'Create Password & Access Portal'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function ClientPortal() {
  const [view, setView] = useState('overview');
  const [showAccountMenu, setShowAccountMenu] = useState(false);
  const [showChangePin, setShowChangePin] = useState(false);
  const [session, setSession] = useState(null);
  const [authChecked, setAuthChecked] = useState(false);
  const [pinUnlocked, setPinUnlocked] = useState(false);
  const [clientData, setClientData] = useState(null);
  const [needsPassword, setNeedsPassword] = useState(false);

  useEffect(() => {
    // Check for invite token in URL
    const hash = window.location.hash;
    if (hash.includes('type=invite') || hash.includes('type=recovery')) {
      setNeedsPassword(true);
    }
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session);
      setAuthChecked(true);
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session);
      if (_event === 'PASSWORD_RECOVERY' || _event === 'USER_UPDATED') {
        setNeedsPassword(false);
      }
    });

    // Re-lock PIN when app is backgrounded and comes back
    const handleVisibility = () => {
      if (document.visibilityState === 'hidden') {
        if (cpGetPin()) setPinUnlocked(false);
      }
    };
    document.addEventListener('visibilitychange', handleVisibility);

    return () => {
      subscription.unsubscribe();
      document.removeEventListener('visibilitychange', handleVisibility);
    };
  }, []);

  useEffect(() => {
    if (!session) return;
    const clientId = session.user?.user_metadata?.client_id;
    if (!clientId) return;
    const loadClientData = async () => {
      const { data, error } = await supabase
        .from('clients')
        .select('*, credentials:credentials(*), service_requests:service_requests(*), network_info')
        .eq('id', clientId)
        .single();
      if (!error && data) {
        setClientData(data);
        // Auto-update invite status to 'active' when client logs in
        if (data.invite_status !== 'active') {
          await supabase
            .from('clients')
            .update({ invite_status: 'active' })
            .eq('id', clientId);
        }
      }
    };
    loadClientData();
  }, [session]);

  if (!authChecked) return null;
  if (needsPassword) return <SetPasswordScreen />;
  if (!session) return <ClientLoginScreen onLoggedIn={() => setPinUnlocked(true)} />;
  if (!pinUnlocked && cpGetPin()) return <ClientPinUnlockScreen onUnlock={() => setPinUnlocked(true)} onSignOut={() => supabase.auth.signOut()} />;
  // Role check - installers should not access client portal
  const role = session.user?.user_metadata?.role;
  if (role === 'installer') {
    return (
      <>
        <style>{styles}</style>
        <div style={{minHeight:'100vh',background:'#F8F5F2',display:'flex',alignItems:'center',justifyContent:'center',flexDirection:'column',gap:16}}>
          <div style={{color:'#E50000',fontSize:16,fontWeight:600}}>Access Denied</div>
          <div style={{color:'#777770',fontSize:13}}>This portal is for clients only.</div>
          <button onClick={() => supabase.auth.signOut()} style={{marginTop:8,background:'#EEEBE7',border:'1px solid #2a2a2a',color:'#555550',padding:'8px 20px',borderRadius:3,cursor:'pointer',fontSize:12}}>Sign Out</button>
        </div>
      </>
    );
  }

  const navItems = [
    { id: 'overview', label: 'Overview', icon: <IconHome/> },
    { id: 'setup', label: 'Account Setup', icon: <IconSetup/> },
    { id: 'devices', label: 'My System', icon: <IconDevices/> },
    { id: 'docs', label: 'Network / WiFi', icon: <IconDocs/> },
    { id: 'support', label: 'Service Request', icon: <IconSupport/> },
    { id: 'upgrade', label: 'Upgrades', icon: <IconUpgrade/> },
  ];

  const renderView = () => {
    switch(view) {
      case 'overview': return <OverviewView setView={setView} clientData={clientData}/>;
      case 'setup': return <SetupView setView={setView} clientData={clientData} setClientData={setClientData}/>;
      case 'devices': return <DevicesView setView={setView} clientData={clientData}/>;
      case 'docs': return <DocsView setView={setView} clientData={clientData}/>;
      case 'support': return <SupportView setView={setView} clientData={clientData}/>;
      case 'upgrade': return <UpgradeView setView={setView}/>;
      default: return <OverviewView setView={setView} clientData={clientData}/>;
    }
  };

  return (
    <>
      <style>{styles}</style>
        <div className="portal-root">
        <nav className="nav">
          <div className="nav-logo" onClick={() => setView('overview')} style={{cursor:'pointer'}}>
            <img src={LOGO_B64} alt="Smart Tech" style={{height:36, maxWidth:200, objectFit:'contain', display:'block', mixBlendMode:'multiply'}} />
          </div>
          <div style={{marginLeft:'auto', display:'flex', alignItems:'center', gap:12}}>
            <div style={{fontSize:9, fontWeight:700, letterSpacing:'0.18em', textTransform:'uppercase', color:'#E50000', background:'rgba(229,0,0,0.08)', border:'1px solid rgba(229,0,0,0.2)', borderRadius:2, padding:'4px 10px'}}>
              {clientData?.system_name || clientData?.name || "Client Portal"}
            </div>
            <div style={{position:'relative'}}>
              <button onClick={() => setShowAccountMenu(m => !m)} style={{background:'transparent', border:'1px solid #D4D1CE', borderRadius:2, padding:'6px 8px', cursor:'pointer', display:'flex', alignItems:'center', gap:4, color:'#777770'}}>
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/>
                </svg>
              </button>
              {showAccountMenu && (
                <div style={{position:'absolute', right:0, top:'calc(100% + 6px)', background:'#FFFFFF', border:'1px solid #D4D1CE', borderRadius:4, minWidth:180, zIndex:200, boxShadow:'0 4px 16px rgba(0,0,0,0.08)'}}
                  onClick={() => setShowAccountMenu(false)}>
                  <button onClick={() => setShowChangePin(true)} style={{width:'100%',textAlign:'left',padding:'12px 16px',background:'none',border:'none',borderBottom:'1px solid #EEEBE7',fontSize:12,color:'#111111',cursor:'pointer',display:'flex',alignItems:'center',gap:8}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg>
                    Change PIN
                  </button>
                  <button onClick={async () => {
                    const email = session?.user?.email;
                    if (email) await supabase.auth.resetPasswordForEmail(email, { redirectTo: window.location.origin + '/portal' });
                    setShowAccountMenu(false);
                    alert('Password reset email sent to ' + email);
                  }} style={{width:'100%',textAlign:'left',padding:'12px 16px',background:'none',border:'none',borderBottom:'1px solid #EEEBE7',fontSize:12,color:'#111111',cursor:'pointer',display:'flex',alignItems:'center',gap:8}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 11-7.778 7.778 5.5 5.5 0 017.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"/></svg>
                    Change Password
                  </button>
                  <button onClick={() => { supabase.auth.signOut(); setShowAccountMenu(false); }} style={{width:'100%',textAlign:'left',padding:'12px 16px',background:'none',border:'none',fontSize:12,color:'#E50000',cursor:'pointer',display:'flex',alignItems:'center',gap:8}}>
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9"/></svg>
                    Sign Out
                  </button>
                </div>
              )}
            </div>
          </div>
        </nav>

        {/* Change PIN Modal */}
        {showChangePin && (
          <ChangePinModal email={session?.user?.email} onClose={() => setShowChangePin(false)} />
        )}


        <div className="hero">
          <div className="hero-eyebrow">Elevating Your Lifestyle Through Technology</div>
          <div className="hero-heading">Your Home,<br/><em>Perfectly Integrated.</em></div>
          <div className="hero-sub">{CLIENT.address}</div>
        </div>

        <div className="main">
          <aside className="sidebar">
            <div className="sidebar-section">
              <div className="sidebar-label">Navigation</div>
              {navItems.map(item => (
                <div
                  key={item.id}
                  className={`sidebar-item ${view === item.id ? 'active' : ''}`}
                  onClick={() => setView(item.id)}
                >
                  {item.icon}
                  <span className="sidebar-text">{item.label}</span>
                  {item.badge && view !== item.id && (
                    <span className="sidebar-badge">{item.badge}</span>
                  )}
                </div>
              ))}
            </div>
            <div className="sidebar-divider"/>
            <div className="sidebar-section">
              <div className="sidebar-label">Contact</div>
              <div style={{padding:'8px 28px'}}>
                <div style={{fontSize:10, color:'#777770', letterSpacing:'0.06em', lineHeight:1.8}}>
                  <div style={{color:'#555550', fontWeight:500, marginBottom:4}}>Smart Tech Utah</div>
                  801-890-3660<br/>
                  info@smarttechutah.com
                </div>
              </div>
            </div>
          </aside>

          <main className="content">
            {renderView()}
          </main>
        </div>
      <div style={{padding:"32px 28px", borderTop:"1px solid #1a1a1a", display:"flex", justifyContent:"center"}}><button onClick={() => supabase.auth.signOut()} style={{background:"transparent", border:"1px solid #2a2a2a", color:"#777770", padding:"10px 28px", borderRadius:2, cursor:"pointer", fontSize:10, fontWeight:700, letterSpacing:"0.12em", textTransform:"uppercase"}}>Sign Out</button></div>
      </div>
    </>
  );
}
